<template>
  <div class="sn-f-col-b-s create-patient">
    <template v-if="showDom">
      <sn-popup :title="title" :cancel="false" @sendBack="sendBack">
        <template v-if="modelRegionMark === '0'">
          <div class="sn-f-col-b-c sn-f-1 patient-region">
            <div class="sn-f-1 integral">
              <div class="sn-f-col-c-c integral-blank">
                <el-form label-position="right" label-width="140px">
                  <div class="sn-f-c-c tab-box" v-if="$sn.getConfig('hasChild').length > 0">
                    <div class="sn-f-c-c sn-f-1 tab-item" :class="{'sn-fc-white sn-bc-main': patientInfo.isChildren === item.type}" :key="item.type" v-for="item in tableArray" @click="getTableClick(item);">
                      <div>{{item.title}}</div>
                    </div>
                  </div>
                  <el-form-item :label="item.title" :required="item.required === '0'" v-for="item in optimizeForms(patientCondition[patientInfo.isChildren])" :key="item.key">
                    <!-- 1 input(el-input)--remark.type: textarea、input 2 radio单选(el-radio-group) 3 select(el-select) 4 省市区组件(el-cascader) 5 日期(el-date-picker) -->
                    <template v-if="item.type === '1'">
                      <el-input v-model="item.value" :class="{'el-input-special': item.key === 'verifyCode', 'el-textarea-special': item.remark.type === 'textarea'}" :placeholder="item.placeholder"
                      :disabled="item.disabled === '0'" resize="none" autosize :maxlength="item.remark.max ? item.remark.max : 140" :type="item.remark.type"></el-input>
                      <el-button v-if="item.key === 'verifyCode'" type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode">{{ buttonLabel }}</el-button>
                    </template>
                    <template v-else-if="item.type === '2'">
                      <div class="radio-blank">
                        <el-radio-group v-model="item.value">
                          <template v-for="(radio, radioIndex) in item.remark">
                            <el-radio :key="radioIndex" :disabled="item.disabled === '0'" :label="radio.value">{{ radio.label }}</el-radio>
                          </template>
                        </el-radio-group>
                      </div>
                    </template>
                    <template v-else-if="item.type === '3'">
                      <el-select v-model="item.value" :placeholder="item.placeholder" :disabled="item.disabled === '0'">
                        <el-option v-for="(option, optionIndex) in item.remark.option" :key="optionIndex" :label="option.itemName" :value="option.itemCode"></el-option>
                      </el-select>
                    </template>
                    <template v-else-if="item.type === '4'">
                      <el-cascader v-model="item.value" :options="item.remark.option" :props="defaultProps" ref="cascader" @change="handleCascadeChange"></el-cascader>
                    </template>
                    <template v-else-if="item.type === '5'">
                      <el-date-picker v-model="item.value" value-format="yyyy-MM-dd" :placeholder="item.placeholder" :disabled="item.disabled === '0'"></el-date-picker>
                    </template>
                  </el-form-item>
                </el-form>
                <div class="sn-prompt sn-bn" v-if="promptInfo.length > 0">
                  <div class="sn-prompt-title">温馨提示</div>
                  <div class="sn-f-s-s sn-prompt-caption" :class="item.style" :key="i" v-for="(item, i) in promptInfo">
                    <div class="sn-prompt-star">★</div>
                    <div v-html="item.info"></div>
                  </div>
                </div>
                <div class="operate-bottom" :class="{'sn-f-b-c': $sn.validate.empty(patientId)}">
                  <div class="sn-f-e-c interaction-bottom">
                    <div class="sn-f-c-c sn-pointer interaction" :class="'interaction-' + item.class" :key="index" v-for="(item, index) in interaction" @click.stop="handlerInteraction(item)">
                      {{ item.caption }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="modelRegionMark === '1'">
          <div class="patient-filing-scheme">
            <div class="sn-padding-0 sn-fs-18 header-title">{{messages.PATIENT046}}</div>
            <div class="sn-padding-0 verification-method">
              <div v-for="(item, index) in way" :key="index">
                <template v-if="item.type === 'ocr'">
                  <div class="sn-fs-16 mode-title">{{item.title}}</div>
                  <div class="sn-pointer sn-f-e-c background-picture" :style="{'background-image': 'url(' + (imgUrl ? imgUrl : (ALI_CLOUD_DOMAIN_STATIC + item.background)) + ')'}" @click="uploadClick();">
                    <div v-if="!imgUrl">
                      <div class="sn-fs-20 sn-fc-text1 sn-fw-bold">点击上传</div>
                      <div class="sub-text">上传您身份证头像面</div>
                    </div>
                    <input type="file" multiple v-show="false" ref="fileInput" @change="uploadImg();" />
                  </div>
                  <div class="upload-require" v-if="captureCredential.title">
                    <span class="border-title">{{$sn.format.caption(captureCredential.title, [captureCredential.distinguish[idTypeFlag].title])}}</span>
                    <div class="sn-fs-20 sn-fc-text3">{{ captureCredential.caption }}</div>
                    <div class="require-line">
                      <div class="require-box" v-for="(el, index) in captureCredential.image" :key="index">
                        <div class="require-img">
                          <img :src="ALI_CLOUD_DOMAIN_STATIC + $sn.format.caption(el.url, [captureCredential.distinguish[idTypeFlag].key])" alt=""/>
                          <span class="iconfont" :class="el.status === '1' ? 'icon-xuanzhong' : 'icon-shanchu-mian- sn-fc-red1'"></span>
                        </div>
                        <div class="require-img-text">{{el.title}}</div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="sn-fs-16 mode-title">{{item.title}}</div>
                  <template v-if="showPhoneMessage">
                    <div class="code-region">
                      您在医院预留的手机号有误，<span class="sn-fc-main sn-fs-16">请及时修改手机号。</span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="code-region">
                      {{showText}}<span class="sn-fc-main">{{$sn.encrypted.phone(exhibitPhone)}}</span>上发送验证码。
                    </div>
                    <div class="sn-f-s-c verification-code">
                      <div class="verification-code-label">动态码：</div>
                      <el-input v-model="patientInfo.verifyPhone" placeholder="请输入动态码" :maxlength="6"></el-input>
                      <el-button type="primary" size="medium" :class="{'sn-bc-background1 sn-fc-text3 sn-bn': buttonLabel !== '获取动态码'}" @click="getVerificationCode()">{{ buttonLabel }}</el-button>
                    </div>
                  </template>
                  <div class="sn-f-b-c submit-btn-box">
                    <div class="sn-pointer sn-fs-16 sn-fc-main" @click="unableEvent();">无法获取动态码？</div>
                    <el-button class="confirm-button" type="primary" size="medium" @click="navigateUrl(showPhoneMessage ? 'return' : 'submit')">下一步</el-button>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </sn-popup>
    </template>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as Tools from '@/common/utils/tools';
import PatientShareMixin from '@/pages/patient/patient-share-mixin';

export default {
  name: 'create-patient',
  mixins: [PatientShareMixin],
  props: {
    // 修改就诊人信息必传：就诊人id
    patientId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDom: false, // 是否显示dom
      title: '添加就诊人', // 弹窗标题
      defaultProps: {
        children: 'children',
        label: 'typeName',
        value: 'typeName'
      }, // cascader组件
      addressCascadeName: [], // cascader组件 地址name暂存
      addressCascadeCode: [], // cascader组件 地址code暂存
      patientInfo: {}, // 就诊人信息
      interaction: [
        { caption: '取消', class: 'cancel', url: 'Cancel' },
        { caption: '确认', class: 'confirm', url: 'Confirm' }
      ], // 底部操作按钮
      tableArray: [
        {
          type: '0',
          title: '成人'
        },
        {
          type: '1',
          title: '儿童'
        }
      ], // 成人/儿童标签
      formItems: {}, // 存储表单字段
      countSecond: 60, // 倒计时秒数，用于验证码失效倒计时
      patientCreationInterval: null, // 定时器
      patientArray: [], // 就诊人数组
      formatFormItems: {}, // 表单数据
      patientCondition: {}, // html上循环的表单信息
      original: [],
      captureCredential: {},
      idTypeFlag: '0',
      modelRegionMark: '0', // 0: 添加 1: 身份校验
      imgUrl: '',
      hospitalDigitalInformation: {}, // 字典数组
      buttonLabel: '获取动态码',
      photographStandard: 0,
      isDebug: false, // 是否是调试模式
      way: [],
      verifyWay: {
        'ocr': {
          type: 'ocr',
          title: '认证方式{0}',
          label: '点击上传',
          subLabel: '上传您身份证头像面',
          button: '前往识别',
          background: '/hos/images/jzr_sfzsb_bj.png'
        },
        'phone': {
          type: 'phone',
          title: '认证方式{0}',
          label: '',
          subLabel: '',
          button: '',
          background: ''
        }
      },
      exhibitPhone: '', // 校验方式显示手机号
      showText: '我们会往您的建档手机号：',
      showPhoneMessage: false, // 是否显示手机号错误提示
      messages: Messages // 提示信息
    };
  },
  computed: {},
  watch: {},
  created: async function() {
    await Tools.dict([this.perpetual.DICTIONARY_CODE_OCCUPATION,
      this.perpetual.DICTIONARY_CODE_CONTACT_RELATIONSHIP,
      this.perpetual.DICTIONARY_CODE_DOCUMENT_TYPE,
      this.perpetual.DICTIONARY_CODE_NATION,
      this.perpetual.DICTIONARY_CODE_CREATE_FILE_MODE,
      this.perpetual.DICTIONARY_CODE_INSURANCE_FILE_CODE]);
    this.hospitalDigitalInformation = this.$sn.utils.getHospitalSessionStorage('HospitalDigitalInformation') ? this.$sn.utils.getHospitalSessionStorage('HospitalDigitalInformation') : {};
    this.captureCredential = await this.patient_mixin_getCaptureCredential('/hos/ui/caption/patient/capture-credential.js');
    this.patient_mixin_getPromptInfo('out', 'addition-patient');
    if (this.$sn.utils.getHospitalLocalStorage('Login_PatientList') && this.$sn.utils.getHospitalLocalStorage('Login_PatientList').length > 0) {
      this.patientArray = this.$sn.utils.getHospitalLocalStorage('Login_PatientList');
    }
    if (this.patientId) {
      // 根据patientId过滤就诊人信息，并且赋值给 patientInfo
      this.patientInfo = this.patientArray.filter(item => item.patientId === this.patientId)[0];
      this.$set(this.patientInfo, 'verifyCode', '');
      this.patient_mixin_formatAddressNation(this.patientInfo);
    }
    else this.patientInfo = this.patient_mixin_valueTransmissionInformation();
    // 获取当前页面表单
    this.getForm();
  },
  methods: {
    // 获取校验方式
    async obtainVerify() {
      // 认证方式开始
      let current = ['ocr'];
      if (!this.$sn.validate.empty(this.$sn.getConfig('additionOutPatientVerify'))) {
        if (this.$sn.validate.array(this.$sn.getConfig('additionOutPatientVerify'))) {
          current = this.$sn.getConfig('additionOutPatientVerify').filter(e => e !== 'face');
        }
      }
      const filterWay = current.map(key => this.verifyWay[key]);
      filterWay.map((el, index) => {
        el.title = filterWay.length > 1 ? this.$sn.format.caption(el.title, [this.$sn.format.nToC(index + 1)]) : '认证方式';
      });
      this.way = filterWay;
      // 认证方式结束
      const sift = this.way.filter(result => result.type === 'phone');
      if (sift.length > 0) await this.getCardInfoByCondition(this.patientInfo);
      this.modelRegionMark = '1';
      this.imgUrl = '';
      this.title = '校验方式';
      this.clearOperation();
    },
    // 获取当前页面表单
    async getForm() {
      this.showDom = false;
      const recombination = await this.patient_mixin_form('create');
      const patientVerifyCondition = this.$sn.getConfig('patientVerifyCondition');
      // 遍历 patientVerifyCondition
      if (patientVerifyCondition && patientVerifyCondition.length > 0) {
        patientVerifyCondition.forEach(condition => {
          let found = false;
          // 寻找是否已经存在于 recombination 中
          for (let i = 0; i < recombination.length; i++) {
            if (recombination[i].key === condition.key) {
              recombination[i] = {
                ...recombination[i], // 保留原来的其他属性
                ...condition // 使用 patientVerifyCondition 中的数据进行更新
              };
              found = true;
            }
          }
          // 如果没找到匹配的 key，则追加到 recombination 中
          if (!found) recombination.push(condition);
        });
      }
      recombination.forEach(item => {
        if (item.key === 'code') {
          item.key = 'verifyCode';
          item.title = '动态码';
          item.placeholder = '请输入动态码';
        }
      });
      this.initial([...recombination]);
    },
    // 初始化页面获取表单
    async initial(recombination) {
      this.$sn.assembly.loading(true);
      const integration = {
        '0': [],
        '1': []
      };
      if (recombination && recombination.length > 0) {
        const patientVerifyConditionType = this.$sn.getConfig('patientVerifyConditionType');
        if (this.$sn.getConfig('isOpenCertificatesType')) {
          const fieldsToInsertAfter = ['nation', 'nationality', 'patientBirthday', 'patientSex'];
          for (const key in patientVerifyConditionType) {
            const index = patientVerifyConditionType[key].indexOf('patientIdCardNo');
            if (index !== -1) {
              patientVerifyConditionType[key].splice(index, 0, 'idCardType');
              patientVerifyConditionType[key].splice(index + 2, 0, ...fieldsToInsertAfter);
            }
          }
        }
        for (const element of recombination) {
          this.$set(element, 'required', element.key === 'nation' ? '1' : '0');
          this.$set(element, 'disabled', '1');
          if (this.$sn.validate.object((element.remark)) && element.remark.url) {
            const type = {
              'relationship': this.perpetual.DICTIONARY_CODE_CONTACT_RELATIONSHIP,
              'certificate': this.perpetual.DICTIONARY_CODE_DOCUMENT_TYPE,
              'nation': this.perpetual.DICTIONARY_CODE_NATION,
              'occupation': this.perpetual.DICTIONARY_CODE_OCCUPATION
            };
            if (['nationality', 'province-city-district'].includes(element.remark.url)) {
              element.remark.option = await this.patient_mixin_getOssStaticResources((element.remark.url));
              if (element.remark.url === 'nationality') {
                element.remark.option.forEach(item => {
                  item.itemName = item.typeName;
                  item.itemCode = item.typeCode;
                });
              }
            }
            else element.remark.option = this.hospitalDigitalInformation[type[element.remark.url]];
          }
          if (element.key === 'relationType') {
            if (this.patientArray.length > 0) {
              this.patientArray.forEach(item => {
                if (this.$sn.validate.empty(this.patientId)) {
                  if (['0', '4'].includes(item.relationType)) {
                    element.remark.option = element.remark.option.filter(relation => ![item.relationType].includes(relation.itemCode));
                  }
                }
              });
            }
          }
          if (element.key === 'idCardType') {
            element.value = '0';
            if (element.remark.option && element.remark.option.length > 0) {
              element.remark.option = element.remark.option.filter(item => this.$sn.getConfig('certificateTypeArray').indexOf(item.itemCode) > -1);
            }
          }
          if (['nation'].includes(element.key)) {
            element.value = element.remark.option.find(item => item.itemName === this.patientInfo[element.key])?.itemCode;
          }
          if (element.key === 'nationality') {
            element.remark.option = element.remark.option.filter(item => item.id && item.itemCode && item.itemName);
          }
        }
        if (patientVerifyConditionType && this.$sn.validate.object(patientVerifyConditionType)) {
          Object.entries(patientVerifyConditionType).forEach(([key, values]) => {
            if (values && values.length > 0) {
              values.forEach((resultKey, index) => {
                const exchange = recombination.find(item => item.key === resultKey);
                if (exchange && exchange.key) {
                  this.$set(exchange, 'sort', index + 1);
                  integration[key].push({ ...exchange });
                }
              });
            }
          });
        }
        if (integration && this.$sn.validate.object(integration)) {
          for (const [key, values] of Object.entries(integration)) {
            if (values && values.length > 0) integration[key] = this.$sn.format.digitalSort(integration[key]);
          }
        }
        if (this.patientId) {
          integration[this.patientInfo.isChildren].forEach(formItem => {
            formItem.disabled = ['nation', 'patientPhone', 'verifyCode', 'habitation', 'detailAddress'].includes(formItem.key) ? '1' : '0';
            if (this.patientInfo[formItem.key]) formItem.value = this.patientInfo[formItem.key];
            if (this.patientInfo.patientBirthday && formItem.key === 'patientBirthday') {
              formItem.value = this.patient_mixin_formatBirthday(this.patientInfo);
            }
            if (this.patientInfo.patientAddress && (formItem.key === 'habitation' || formItem.key === 'detailAddress')) {
              const regionInitial = [this.patientInfo.province, this.patientInfo.city, this.patientInfo.county].filter(address => address);
              if (formItem.key === 'habitation') {
                const province = this.patientInfo.province;
                const city = this.patientInfo.city;
                const county = this.patientInfo.county;
                // 地址如果传的是code的情况下
                // if (this.patientInfo.province && formItem.remark.option.filter(province => province.typeName === this.patientInfo.province).length > 0) {
                //   province = formItem.remark.option.filter(province => province.typeName === this.patientInfo.province)[0].typeCode;
                // }
                // formItem.remark.option.forEach(father => {
                //   if (father.children.length > 0) {
                //     if (this.patientInfo.city && father.children.filter(city => city.typeName === this.patientInfo.city).length > 0) {
                //       city = father.children.filter(city => city.typeName === this.patientInfo.city)[0].typeCode;
                //     }
                //     father.children.forEach(son => {
                //       if (this.$sn.validate.object(son.children)) {
                //         county = son.typeCode;
                //       }
                //       if (this.$sn.validate.array(son.children)) {
                //         if (son.children.length > 0) {
                //           if (this.patientInfo.county && son.children.filter(county => county.typeName === this.patientInfo.county).length > 0) {
                //             county = son.children.filter(county => county.typeName === this.patientInfo.county)[0].typeCode;
                //           }
                //         }
                //       }
                //     });
                //   }
                // });
                this.addressCascadeName = [province, city, county];
                formItem.value = [province, city, county];
              }
              if (formItem.key === 'detailAddress') {
                formItem.value = regionInitial.length > 0 ? this.patientInfo.patientAddress.replace(regionInitial.join(''), '') : this.patientInfo.patientAddress;
              }
            }
            if (['patientName'].includes(formItem.key)) formItem.value = this.patientInfo.nameEncrypt;
            if (['patientIdCardNo'].includes(formItem.key)) formItem.value = this.patientInfo.idCardEncrypt;
            if (['nation', 'nationality', 'occupation'].includes(formItem.key)) {
              formItem.value = formItem.remark.option.find(item => item.itemName === this.patientInfo[formItem.key])?.itemCode;
            }
          });
        }
        this.title = this.patientId ? '编辑就诊人' : '添加就诊人';
        this.patientCondition = integration;
        this.original = JSON.stringify(integration);
        this.showDom = true;
      }
      else this.$emit('sendBack', false);
      this.$sn.assembly.loading(false);
    },
    // 优化表单数据
    optimizeForms(array) {
      let formArray = [];
      // 定义需要排除的键
      const excludeKeys = {
        adult: {
          '0': ['nationality', 'patientBirthday', 'patientSex'],
          '1': ['nation'],
          '2': ['nationality']
        },
        children: {
          '0': ['nationality'],
          '1': ['nation'],
          '2': ['nationality']
        }
      };
      const separate = {
        '0': 'adult',
        '1': 'children'
      };
      // 判断身份证类型
      const idCardType = array.find(obj => obj.key === 'idCardType')?.value;
      // 根据条件过滤数组
      let filteredKeys = [];
      if (idCardType === '0') filteredKeys = excludeKeys[separate[this.patientInfo.isChildren]]['0'];
      else if (['1', '3'].includes(idCardType)) filteredKeys = excludeKeys[separate[this.patientInfo.isChildren]]['1'];
      else if (['0', '2', '4'].includes(idCardType)) filteredKeys = excludeKeys[separate[this.patientInfo.isChildren]]['2'];
      // 过滤数组
      formArray = array.filter(obj => !filteredKeys.includes(obj.key));
      if (this.patientInfo.isChildren === '1') formArray = formArray.filter(obj => !['relationType'].includes(obj.key));
      if (this.patientId) formArray = formArray.filter(obj => !['occupation'].includes(obj.key));
      return formArray;
    },
    // 获取不到验证码
    unableEvent() {
      this.$sn.assembly.modal({
        title: '获取不到动态码？',
        caption: Messages.PATIENT047,
        captionConfirm: '我知道了',
        isCancel: false
      });
    },
    // 获取卡号
    getCardInfoByCondition(info) {
      const params = {
        url: Swagger.getCardInfoByCondition,
        query: {
          patientId: info.patientIdCardNo,
          hosId: this.$sn.utils.getHospitalId(),
          hosArea: '',
          bindType: this.$sn.utils.getPlatformType(),
          openId: this.$sn.utils.getOpenId(),
          clinicType: '1'
        },
        header: true
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.length > 0) {
            if (!this.$sn.validate.phone(result.data[0].cardPhone)) this.showPhoneMessage = true;
            else this.exhibitPhone = result.data[0].cardPhone;
          }
          else {
            this.exhibitPhone = this.$sn.utils.getLoginPhone();
            this.showText = '我们会往您的登录手机号：';
          }
        }
        else this.showPhoneMessage = true;
      });
    },
    // 提交表单
    formatPatientAndFormItems(type, array) {
      this.patientInfo.nationality = '';
      this.patientInfo.nationalityCode = '';
      this.patientInfo.province = '';
      this.patientInfo.city = '';
      this.patientInfo.county = '';
      this.patientInfo.patientAddress = '';
      array.forEach(formItem => {
        if (this.patientId) {
          if (!['patientName', 'patientIdCardNo', 'nationality', 'nation', 'habitation', 'detailAddress', 'occupation'].includes(formItem.key)) {
            this.patientInfo[formItem.key] = formItem.value;
          }
        }
        else {
          if (!['nationality', 'nation', 'habitation', 'detailAddress', 'occupation'].includes(formItem.key)) {
            this.patientInfo[formItem.key] = formItem.value;
          }
        }
        if (type === 'increase') {
          if (['1', '3'].includes(this.patientInfo.idCardType) && formItem.key === 'nationality') {
            this.patientInfo.nation = '';
            this.patientInfo.nationality = formItem.remark.option.find(item => item.itemCode === formItem.value)?.itemName || '';
            this.patientInfo.nationalityCode = formItem.value;
          }
          if (['0'].includes(this.patientInfo.idCardType) && this.patientInfo.isChildren === '0') {
            this.patientInfo.patientSex = '';
            this.patientInfo.patientBirthday = '';
          }
        }
        if (['0', '2', '4'].includes(this.patientInfo.idCardType) && formItem.key === 'nation') {
          this.patientInfo.nation = formItem.remark.option.find(item => item.itemCode === formItem.value)?.itemName || '';
        }
        if (['habitation', 'detailAddress'].includes(formItem.key)) {
          // addressCascadeName 传汉字 addressCascadeCode 传code
          if (this.addressCascadeName && this.addressCascadeName.length > 0) {
            this.patientInfo.province = this.addressCascadeName[0] || '';
            this.patientInfo.city = this.addressCascadeName[1] || '';
            this.patientInfo.county = this.addressCascadeName[2] || '';
            this.patientInfo.patientAddress = this.addressCascadeName.join('') + (['detailAddress'].includes(formItem.key) ? formItem.value : '');
          }
        }
        if (['occupation'].includes(formItem.key)) {
          this.patientInfo.occupation = formItem.remark.option.filter(item => item.itemCode === formItem.value)[0]?.itemName || '';
          this.patientInfo.occupationCode = formItem.value;
        }
      });
    },
    // 切换成人/儿童
    getTableClick(item) {
      if (this.patientInfo.isChildren === item.type) return false;
      this.patientCondition = JSON.parse(this.original);
      this.patientInfo.isChildren = item.type;
      this.patientInfo.relationType = this.patientInfo.isChildren === '0' ? '' : '2';
    },
    // 省市区联动
    handleCascadeChange(value) {
      this.addressCascadeName = this.$refs.cascader[0].getCheckedNodes()[0].pathLabels;
      this.addressCascadeCode = value;
    },
    // 点击上传按钮
    uploadClick() {
      this.photographStandard = 0;
      this.$refs.fileInput[0].value = '';
      this.$refs.fileInput[0].click();
    },
    // 上传图片
    uploadImg() {
      if (this.$refs.fileInput[0].files.length > 1) {
        this.getShowToast(this.$sn.format.caption(Messages.C005, ['一']));
        return false;
      }
      if (this.$refs.fileInput[0].files.length === 0) return false;
      this.$sn.assembly.loading(true);
      Tools.uploadFile(this.perpetual.UPLOAD_TYPE_JZR, this.$refs.fileInput[0].files, 1, this.perpetual.IMAGE_SIZE, this.uploadImageCallBack);
    },
    // 上传图片回调
    async uploadImageCallBack(type, result, file) {
      this.$sn.assembly.loading(false);
      if (type) {
        this.photographStandard++;
        if (this.photographStandard === file.length) {
          this.$sn.assembly.loading(true);
          const single = await Tools.getPrivateResourceUrl(this.perpetual.UPLOAD_TYPE_JZR, file[0].trajectory.split(';'));
          this.$sn.assembly.loading(false);
          this.imgUrl = single[0];
          this.patientInfo.verifyPhone = '';
          this.patientInfo.ocrContent = this.imgUrl;
          this.createPatientInfo();
        }
      }
      else this.getShowToast(result.msg);
    },
    clearOperation() {
      this.patientInfo.verifyPhone = '';
      this.patientInfo.ocrContent = '';
      this.buttonLabel = '获取动态码';
      this.countSecond = 60;
    },
    // 确认、提交操作
    handlerInteraction(item) {
      const patientCondition = this.optimizeForms(this.patientCondition[this.patientInfo.isChildren]);
      if (item.url === 'Confirm') {
        if (patientCondition.filter(result => result.required === '0' && this.$sn.validate.empty(result.value)).length > 0) {
          this.getShowToast(Messages.PATIENT061);
          return false;
        }
        this.formatPatientAndFormItems(this.patientId ? '' : 'increase', patientCondition);
        if (this.patientInfo.idCardType === '0') {
          if (this.$sn.validate.empty(this.patientId)) {
            if (this.patientInfo.patientIdCardNo && !this.$sn.validate.idCardSerial(this.patientInfo.patientIdCardNo)) {
              this.getShowToast(this.$sn.format.caption(Messages.SEARCH001, ['正确的就诊人身份证号']));
              return false;
            }
            if (this.patientInfo.guardianIdCardNo && !this.$sn.validate.idCardSerial(this.patientInfo.guardianIdCardNo)) {
              this.getShowToast(this.$sn.format.caption(Messages.SEARCH001, ['正确的监护人身份证号']));
              return false;
            }
          }
          if (this.patientInfo.patientPhone && !this.$sn.validate.phone(this.patientInfo.patientPhone)) {
            this.getShowToast(this.$sn.format.caption(Messages.SEARCH001, ['正确的手机号']));
            return false;
          }
        }
        if (this.$sn.validate.empty(this.patientId) && this.patientArray.length > 0) {
          let verify = false;
          if (this.patientInfo.isChildren === '0') {
            verify = this.patientArray.filter(patient => patient.patientIdCardNo === this.patientInfo.patientIdCardNo).length > 0;
          }
          if (!this.$sn.getConfig('IDCardCanrepeat') && verify) {
            this.getShowToast(Messages.PATIENT022);
            return false;
          }
          if (this.patientArray.filter(patient => patient.defaultState === '1').length === 0) this.patientInfo.defaultState = '1';
        }
        this.patientInfo.patientPresentAddress = this.patientInfo.patientAddress;
        if (this.patientId) this.modifyPatientInfo();
        else {
          // 1.idCardType: 0 的情况下：根据身份证号判断年龄 > 14岁，需要实名校验；< 14岁 不需要实名校验
          // 2.idCardType: !0 的情况下：不需要校验
          if (this.patientInfo.idCardType === '0') {
            const birth = this.$sn.format.ageByBirthday(this.$sn.format.birthdayByIdCardSerial(this.patientInfo.patientIdCardNo));
            if (birth > this.$sn.getConfig('isChildAge')) {
              if (!this.isDebug) this.obtainVerify();
              else this.createPatientInfo();
            }
            else this.createPatientInfo();
          }
          else this.createPatientInfo();
        }
      }
      else if (item.url === 'Cancel') {
        if (this.modelRegionMark === '1') {
          this.modelRegionMark = '0';
          this.title = '添加就诊人';
          return false;
        }
        this.sendBack(false);
      }
    },
    // 倒计时
    startCountDown() {
      this.patientCreationInterval = setInterval(() => {
        if (this.countSecond > 0) {
          this.countSecond--; // 每隔1秒将倒计时减少1
          this.buttonLabel = '重新发送' + this.countSecond + 's';
        }
        else {
          // 如果倒计时结束则清除定时器
          if (this.patientCreationInterval) clearInterval(this.patientCreationInterval);
          this.buttonLabel = '获取动态码';
          this.countSecond = 60;
        }
      }, 1000);
    },
    // 获取验证码
    getVerificationCode() {
      let patientPhone = '';
      if (this.modelRegionMark === '1') patientPhone = this.exhibitPhone;
      else {
        if (this.optimizeForms(this.patientCondition[this.patientInfo.isChildren]).filter(el => el.key === 'patientPhone').length > 0) {
          patientPhone = this.optimizeForms(this.patientCondition[this.patientInfo.isChildren]).filter(el => el.key === 'patientPhone')[0].value;
        }
      }
      if (this.$sn.validate.empty(patientPhone)) {
        this.getShowToast(this.$sn.format.caption(Messages.PATIENT040, ['手机号']));
        return false;
      }
      if (this.buttonLabel === '获取动态码') {
        if (this.$sn.validate.phone(patientPhone)) {
          const params = {
            url: Swagger.sendCode,
            method: 'POST',
            header: true,
            data: JSON.stringify({
              hosId: this.$sn.utils.getHospitalId(),
              mobile: patientPhone,
              platformType: this.$sn.utils.getPlatformType(),
              projectType: '',
              codeType: '5'
            })
          };
          this.$sn.assembly.loading(true);
          this.$sn.utils.ordinaryRequest(params).then(result => {
            this.$sn.assembly.loading(false);
            if (result && result.code === 0) {
              this.startCountDown();
              // 弹窗提示消息 动态码短信已发送至
              this.getShowToast(this.$sn.format.caption(Messages.PATIENT023, [this.$sn.encrypted.phone(patientPhone)]));
            }
            else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
          });
        }
        else this.getShowToast(Messages.C013);
      }
    },
    // 创建就诊人
    createPatientInfo() {
      const params = {
        url: this.isDebug ? Swagger.createPatientInfo : Swagger.upgradeCreatePatientInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify(this.patientInfo)
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.data && result.code === 0) {
          this.patientArray.push(result.data);
          this.$sn.utils.setHospitalLocalStorage('CurrentPatient', result.data);
          this.$sn.utils.setHospitalLocalStorage('Login_PatientList', this.patientArray);
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C016, ['添加就诊人']),
            mode: 'success',
            success: () => {
              this.sendBack(true, result.data);
            }
          });
        }
        else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
      });
    },
    // 修改就诊人
    modifyPatientInfo() {
      const params = {
        url: Swagger.upgradeModifyPatientInfo,
        method: 'POST',
        header: true,
        data: JSON.stringify(this.patient_mixin_valueModifyTransmissionInformation(this.patientInfo))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.data && result.code === 0) {
          const patient = {
            ...this.patentInfo,
            ...result.data
          };
          Tools.modifyPatientInfo(result.data.patientId, patient);
          this.$sn.assembly.toast({
            caption: this.$sn.format.caption(Messages.C016, ['修改就诊人']),
            mode: 'success',
            success: () => {
              this.sendBack(true, patient);
            }
          });
        }
        else this.getShowToast(result && result.msg ? result.msg : Messages.C001);
      });
    },
    // 回传父组件
    sendBack(type, item) {
      if (this.patientCreationInterval) clearInterval(this.patientCreationInterval);
      this.$emit('sendBack', type, type ? item : '');
    },
    // 单纯的弹窗显示信息
    getShowToast(caption) {
      this.$sn.assembly.toast({
        caption: caption
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'submit') {
        this.patientInfo.ocrContent = '';
        this.createPatientInfo();
      }
      else if (url === 'return') {
        this.modelRegionMark = '0';
        this.title = '添加就诊人';
        this.clearOperation();
      }
      else {
        this.$router[type]({
          path: url,
          query: params
        });
      }
    }
  },
  beforeDestroy() {
    if (this.patientCreationInterval) clearInterval(this.patientCreationInterval);
  }
};
</script>
<style lang="scss" scoped>
.create-patient {
  overflow: hidden;
  z-index: 100;

  ::v-deep .popup {
    width: 650px;
  }

  .patient-region {
    overflow: hidden;
    width: 100%;
    padding: 20px 20px 20px 0;
    max-height: 80vh;

    .integral {
      overflow-x: hidden;
      overflow-y: auto;
      width: 100%;

      .integral-blank {
        .tab-box {
          width: 200px;
          border-radius: 3px;
          margin-bottom: 20px;
          margin-left: 100px;

          .tab-item {
            border: 1px solid $main;
            background-color: $white;
            font-size: 14px;
            color: $main;
            padding: 5px 0;
          }
        }

        .el-form-item__content-special {
          display: flex;
          justify-content: flex-start;
        }

        .el-input,
        .el-select,
        .el-cascader,
        .el-textarea,
        .el-date-editor {
          width: 300px;
        }

        .el-input-special {
          width: 170px;
        }

        .radio-blank {
          border: 1px solid $border1;
          padding: 0 14px;
          border-radius: 4px;
          width: 300px;
          display: inline-block;
        }

        .el-radio-group {
          .is-checked {
            .el-radio__inner {
              border: none;
              background-color: $main;
            }

            .el-radio__label {
              color: $main;
            }
          }
        }

        .el-input,
        .el-button {
          height: 40px;
        }

        .el-button {
          margin-left: 10px;
          width: 120px;
          background-color: $main;
          border: none;
        }

        .operate-bottom {
          width: 100%;
          padding-left: 20px;
        }

        .interaction-bottom {
          overflow: hidden;
          width: 100%;
          margin-bottom: 10px;

          .interaction {
            width: 120px;
            height: 40px;
            font-size: 16px;
            border: 1px solid $main;
            border-radius: 5px;
            margin-left: 10px;

            &:first-child {
              margin-left: 0;
            }

            &-confirm {
              background-color: $main;
              color: $white;
            }

            &-cancel {
              background-color: $white;
              color: $main;
            }
          }
        }
      }
    }
  }

  .patient-filing-scheme {
    padding: 0 20px 10px;

    .sn-padding-0 {
      padding: 0;
    }

    .header-title,
    .mode-title {
      font-weight: bold;
      color: $text1;
      margin: 10px 0;
    }

    .verification-method {
      .code-region {
        font-size: 15px;
        line-height: normal;
        margin-top: 8px;
        color: $text1;
      }

      .verification-code {
        font-size: 15px;
        margin-top: 20px;
        width: 100%;

        &-label {
          width: 15%;
        }

        .el-input {
          width: 70%;
        }

        .el-button {
          margin-left: 5px;
          width: 120px;
          background-color: $main;
          border: none;
          height: 40px;
        }
      }

      .submit-btn-box {
        margin: 40px 0;

        .confirm-button {
          padding: 10px 25px;
          background-color: $main;
        }
      }

      .background-picture {
        font-size: 24px;
        margin: 16px 0 0;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
        height: 180px;
        padding: 0 60px;

        .sub-text {
          font-size: 18px;
          margin: 8px 0 0;
          color: $text3;
        }
      }

      .upload-require {
        border: dashed 2px $border1;
        border-radius: 10px;
        display: inline-block;
        margin: 30px 0 10px;
        position: relative;
        padding: 20px 20px 0;

        .border-title {
          position: absolute;
          top: -20px;
          left: 20px;
          color: $text1;
          background-color: $white;
          font-size: 20px;
          padding: 0 10px;
        }

        .require-line {
          width: 100%;
          margin: 20px 0;
          display: flex;
          flex-wrap: wrap;

          .require-box {
            width: 23.5%;
            position: relative;
            text-align: center;
            margin-right: 2%;

            .require-img {
              position: relative;

              img {
                width: 100%;
                height: 100%;
              }

              .iconfont {
                position: absolute;
                bottom: -10px;
                left: 42%;
                font-size: 24px;
              }

              .icon-xuanzhong {
                color: $green4;
              }

              &-text {
                margin-top: 16px;
                font-size: 20px;
                color: $text3;
                text-align: center;
              }
            }

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }

  ::v-deep .el-input {
    .el-input__inner:focus {
      border-color: $main !important;
    }
  }

  ::v-deep .el-textarea-special {
    min-height: 40px !important;

    .el-textarea__inner {
      line-height: 2;
      min-height: 40px !important;
    }

    .el-textarea__inner:focus {
      border-color: $main !important;
    }

    .el-textarea__inner::placeholder {
      font-family: "PingFang SC", "Microsoft YaHei", Arial, sans-serif;
    }
  }
}
</style>
